/**
 * Toolbar dropdowns (Paragraph/Heading, font family/size, align) steal focus
 * from the Froala field before the command runs. With no live selection,
 * paragraphFormat applies to an empty block and the field's text vanishes.
 * Save the caret on toolbar mousedown; restore it before those commands.
 */

export const BLOCK_FORMAT_COMMANDS = [
  "align",
  "alignLeft",
  "alignCenter",
  "alignRight",
  "alignJustify",
  "paragraphFormat",
  "fontFamily",
  "fontSize",
];

const BLOCK_TAG_RE = /<(p|h[1-6]|ul|ol|div|blockquote|table)\b/i;

export function wrapLooseTextInParagraph(editor) {
  if (!editor?.html?.get || !editor?.html?.set) return false;
  const html = editor.html.get() || "";
  const text = (editor.el?.textContent || "").trim();
  if (!text || BLOCK_TAG_RE.test(html)) return false;
  editor.html.set(`<p>${html}</p>`);
  return true;
}

export function saveEditorSelection(editor) {
  if (!editor?.selection) return;
  if (typeof editor.selection.inEditor === "function" && !editor.selection.inEditor()) {
    return;
  }
  if (typeof editor.selection.save === "function") editor.selection.save();
}

export function restoreEditorSelectionForCommand(editor, cmd) {
  if (!editor?.selection || !BLOCK_FORMAT_COMMANDS.includes(cmd)) return;
  if (typeof editor.selection.inEditor === "function" && editor.selection.inEditor()) {
    return;
  }
  if (editor.events?.focus) editor.events.focus();
  if (typeof editor.selection.restore === "function") editor.selection.restore();
  const stillOutside =
    typeof editor.selection.inEditor === "function" && !editor.selection.inEditor();
  if (!stillOutside) return;
  if (cmd === "paragraphFormat") wrapLooseTextInParagraph(editor);
  if (
    editor.$el?.get &&
    typeof editor.selection.setAtEnd === "function"
  ) {
    editor.selection.setAtEnd(editor.$el.get(0));
    if (typeof editor.selection.restore === "function") editor.selection.restore();
  }
}
